export default __webpack_public_path__ + "static/media/extension_giftcard_gold_w3.4367a589.svg";